import { render, staticRenderFns } from "./iconBuy.vue?vue&type=template&id=66cd7401&scoped=true"
import script from "./iconBuy.vue?vue&type=script&lang=js"
export * from "./iconBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cd7401",
  null
  
)

export default component.exports